import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { useCallback } from "react";
import { useRef } from 'react';

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useUserContext } from '../../context/DealerProfile';

import useSWR from "swr";

const fetcher = (url) => fetch(url).then((res) => res.json());


const ContactsPage = () => {
  const [fields, setFields] = useState([]);
  const { dealerDetail } = useUserContext();
  const [formData, setFormData] = useState({});
  const [isFieldsLoading, setIsFieldsLoading] = useState(true);
  const [loading, setLoading] = useState(true);
  const [options, setOptions] = useState({});
  const [errors, setErrors] = useState({});
  const [sections, setSections] = useState([]);
  const [subDisposition, setSubDisposition] = useState("");


  const navigate = useNavigate(); // Initialize useNavigate

  const { id } = useParams();

  const idToFetch = id;
  const module = "Leads";

  // useEffect(() => {
  //   const fetchFieldsAndSections = async () => {
  //     setIsFieldsLoading(true);
  //     try {
  //       const response = await fetch(`/server/dealer_backend/getLayout?module=${module}`);
  //       const data = await response.json();

  //       console.log(data)

  //       if (data.status === "success") {
  //         const layout = data.data.find(layout => layout.layout_name === "IFR");

  //         if (!layout) {
  //           console.warn("No layout with layout_name === 'IFR' found.");
  //           return;
  //         }

  //         const usableSections = layout.sections
  //           .filter(section => Array.isArray(section.fields) && section.fields.some(f => f.type === "used"))
  //           .map(section => ({
  //             ...section,
  //             fields: section.fields.filter(f => f.type === "used")
  //           }))
  //           .filter(section => section.fields.length > 0);

  //         // console.log(usableSections)

  //         const allFilteredFields = usableSections.flatMap(section => section.fields);

  //         setSections(usableSections);
  //         setFields(allFilteredFields);

  //         // ✅ Set default values for IFR Lead Sources and Nationality
  //         const leadSourceField = allFilteredFields.find(f => f.display_label === "IFR Lead Source");
  //         const nationalityField = allFilteredFields.find(f => f.display_label === "Nationality");

  //         setFormData(prev => ({
  //           ...prev,
  //           ...(leadSourceField ? { [leadSourceField.name]: "Face to Face" } : {}),
  //           ...(nationalityField ? { [nationalityField.name]: "Indian" } : {})
  //         }));
  //       } else {
  //         console.error("Failed to fetch layout data:", data.error);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching layout data:", error);
  //     } finally {
  //       setIsFieldsLoading(false);
  //     }
  //   };

  //   fetchFieldsAndSections();
  // }, []);

  // Use SWR hook to fetch layout data


  const { data, error, isLoading } = useSWR(
    `/server/dealer_backend/getLayout?module=${module}`,
    fetcher
  );

  useEffect(() => {
    if (error) {
      console.error("Failed to fetch layout data:", error);
      setIsFieldsLoading(false);
      return;
    }
    if (data) {
      setIsFieldsLoading(false);

      if (data.status === "success") {
        const layout = data.data.find((layout) => layout.layout_name === "IFR");

        if (!layout) {
          console.warn("No layout with layout_name === 'IFR' found.");
          return;
        }

        const usableSections = layout.sections
          .filter(
            (section) =>
              Array.isArray(section.fields) &&
              section.fields.some((f) => f.type === "used")
          )
          .map((section) => ({
            ...section,
            fields: section.fields.filter((f) => f.type === "used"),
          }))
          .filter((section) => section.fields.length > 0);

        const allFilteredFields = usableSections.flatMap(
          (section) => section.fields
        );

        console.log({allFilteredFields});

        setSections(usableSections);
        setFields(allFilteredFields);

        // Set default values for IFR Lead Source and Nationality
        const leadSourceField = allFilteredFields.find(
          (f) => f.display_label === "IFR Lead Source"
        );
        const nationalityField = allFilteredFields.find(
          (f) => f.display_label === "Nationality"
        );

        setFormData((prev) => ({
          ...prev,
          ...(leadSourceField ? { [leadSourceField.name]: "Face to Face" } : {}),
          ...(nationalityField ? { [nationalityField.name]: "Indian" } : {}),
        }));
      } else {
        console.error("Failed to fetch layout data:", data.error);
      }
    }
  }, [data, error]);










  const handleFieldChange = async (label, value) => {
    // console.log(label)
    const apiName = labelToApiNameMap.current[label];
    const updatedFormData = { ...formData, [apiName]: value };


    if (label === "Zip Code" && value.length === 6) {
      try {
        const response = await fetch(`https://api.postalpincode.in/pincode/${value}`);

        const data = await response.json();
        console.log("API response:", data[0].PostOffice[0]);

        if (data[0].PostOffice[0] && data[0].PostOffice[0].State && data[0].PostOffice[0].District) {
          updatedFormData[labelToApiNameMap.current["City"]] = data[0].PostOffice[0].District;
          updatedFormData[labelToApiNameMap.current["State"]] = data[0].PostOffice[0].State;
          updatedFormData[labelToApiNameMap.current["Country"]] = data[0].PostOffice[0].Country || "India";
        }
      } catch (err) {
        console.error(" API call failed:", err);
      }
    }



    setFormData(updatedFormData);
  };






  const handleInputChange = useCallback((e) => {
    const { name, type, value, checked } = e.target;

    const newValue = type === "checkbox" ? checked : value;

    // Validation
    let error = "";
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10}$/;

    if (name === "Email" && newValue && !emailRegex.test(newValue)) {
      error = "Please enter a valid email address.";
    }

    if (name === "Secondary_Email" && newValue && !emailRegex.test(newValue)) {
      error = "Please enter a valid email address.";
    }

    if (name === "Mobile" && newValue && !phoneRegex.test(newValue)) {
      error = "Phone number must be a 10-digit number.";
    }

    if (name === "Phone" && newValue && !phoneRegex.test(newValue)) {
      error = "Phone number must be a 10-digit number.";
    }



    setFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  }, []);




  // Function to fetch picklist values



  const salutationGenderMap = {
    "Mr.": "Male",
    "Mrs.": "Female",
    "Ms.": "Female",
    "Dr.": "",      // Neutral or unknown
    "Prof.": "",    // Neutral or unknown
  };







  // Function to render the appropriate input field based on its type
  const renderInputField = (field) => {
    const fieldValue = formData[field.name] || "";
    const isReadOnlyLeadStatus = field.display_label === "";


    // Special rendering for "Catalyst User"
    if (field.label === "Catalyst User") {
      return (
        <select
          name={field.name}
          value={fieldValue}
          onChange={(e) => {
            const selectedName = e.target.value;
            const selectedUser = catalystUsers.find(user => user.Name === selectedName);
            setFormData(prev => ({
              ...prev,
              [field.name]: selectedName,
              Catalyst_User_Email: selectedUser?.Email || ""
            }));
          }}
        >
          <option value="">Select User</option>
          {catalystUsers.map(user => (
            <option key={user.id} value={user.Name}>
              {user.Name}
            </option>
          ))}
        </select>
      );
    }

    // Main switch
    switch (field.data_type) {
      case "integer":
      case "currency":
      case "bigint":
        if (field.display_label === "Donation Amount") {
          return (
            <input
              type="number"
              name={field.name}
              min="0"
              step="0.01"
              value={formData[field.name] || ""}
              onChange={(e) => {
                const value = parseFloat(e.target.value);
                if (value >= 0 || e.target.value === "") {
                  handleInputChange(e);
                }
              }}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none ${errors[field.name] ? "border-red-500" : "border-gray-300"
                }`}
            />
          );
        }
        return <input type="number" name={field.name} value={fieldValue} onChange={handleInputChange} step="0.01" />;

      case "datetime":
        return <input type="datetime-local" className='' name={field.name} value={fieldValue} onChange={handleInputChange} />;

      case "date":
        return <input type="date" name={field.name} className='' value={fieldValue} onChange={handleInputChange} />;

      case "text":
      case "email":
      case "ownerlookup":
      case "phone":
      case "website":
        // 👇 Special handling for First Name
        if (field.display_label === "First Name") {
          return (
            <div className="first-name-field flex rounded border overflow-hidden">

              {/* Salutation dropdown */}
              <select
                className="salutation-select px-2 py-2 bg-white border-r border-gray-300 outline-none focus:ring-0"
                value={formData.Salutation || ""}
                onChange={(e) => {
                  const Salutation = e.target.value;

                  // Auto-set gender based on salutation
                  const autoGender = salutationGenderMap[Salutation] || "";

                  setFormData(prev => ({
                    ...prev,
                    Salutation,                // store separately
                    Gender: autoGender || prev.Gender // update gender if mapped
                  }));
                }}
              >
                <option value="">-None-</option>
                <option value="Mr.">Mr.</option>
                <option value="Mrs.">Mrs.</option>
                <option value="Ms.">Ms.</option>
                <option value="Dr.">Dr.</option>
                <option value="Prof.">Prof.</option>
              </select>

              {/* First name input */}
              <input
                type="text"
                placeholder="Enter First Name"
                className="px-2 py-2 outline-none focus:ring-0 flex-1"
                value={formData.First_Name || ""}   // now only first name here
                onChange={(e) => {
                  const firstName = e.target.value;
                  setFormData(prev => ({
                    ...prev,
                    First_Name: firstName         // no salutation concatenation
                  }));
                }}
              />
            </div>
          );
        }



        // 👇 Normal text/email/phone fields
        return (
          <div className="w-full">
            <input
              type={field.type}
              name={field.name}
              value={formData[field.name] || ""}
              onChange={(e) => {
                const val = e.target.value;
                if (field.display_label === "Zip Code") {
                  handleFieldChange(field.display_label, val);
                } else {
                  handleInputChange(e);
                }
              }}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none ${errors[field.name] ? "border-red-500" : "border-gray-300"
                }`}
            />
            {errors[field.name] && (
              <p className="text-sm text-red-500 mt-1">{errors[field.name]}</p>
            )}
          </div>
        );

      case "boolean":
        return <input type="checkbox" name={field.name} checked={formData[field.name] || false} onChange={handleInputChange} />;

      case "picklist":
        const picklistValues = options[field.id];
        return (
          <select
            name={field.name}
            value={fieldValue}
            onChange={isReadOnlyLeadStatus ? undefined : handleInputChange}
            disabled={isReadOnlyLeadStatus}
          >
            {!picklistValues ? (
              <option disabled>Loading...</option>
            ) : (
              picklistValues.map((option, idx) => (
                <option key={idx} value={option}>
                  {option}
                </option>
              ))
            )}
          </select>
        );

      case "profileimage":
        return <input type="file" name={field.name} onChange={handleInputChange} accept="image/*" />;

      case "lookup":
        return (
          <select name={field.name} value={fieldValue} onChange={handleInputChange}>
            {field.lookupValues?.length ? (
              field.lookupValues.map((option, index) => (
                <option key={index} value={option.value}>
                  {option.label}
                </option>
              ))
            ) : (
              <option disabled>No options available</option>
            )}
          </select>
        );

      default:
        return <input type="text" name={field.name} value={fieldValue} onChange={handleInputChange} />;
    }
  };



  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   // console.log("Submitting:", formData);



  //   // Prepare formData for submission
  //   const transformedData = { ...formData };

  //   // If Catalyst_User is stored as a name in formData, find its ID
  //   const selectedCatalystUser = catalystUsers.find(user => user.Name === formData.Catalyst_User);
  //   if (selectedCatalystUser) {
  //     transformedData.Catalyst_User = {
  //       id: selectedCatalystUser.id,
  //       name: selectedCatalystUser.Name,
  //     };
  //   }

  //   // Optional: if you also want to send Catalyst_User_Email as separate field (not nested)
  //   transformedData.Catalyst_User_Email = selectedCatalystUser?.Email || "";

  //   const requestBody = {
  //     data: [transformedData], // Wrap inside `data` array
  //   };

  //   try {
  //     const response = await fetch("/server/dealer_backend/handleLeads", {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(requestBody),
  //     });

  //     const result = await response.json();
  //     // console.log("Response:", result);

  //     const idFetch = result.data.data[0].details?.id;
  //     if (result.status === "success") {
  //       toast.success("Lead stored successfully!");
  //       navigate(`/owner-details/${idFetch}`);

  //       // Clear form after submission
  //       setFormData((prev) =>
  //         Object.keys(prev).reduce((acc, key) => {
  //           acc[key] = "";
  //           return acc;
  //         }, {})
  //       );
  //     } else {
  //       console.error("Error:", result.error);
  //       toast.error("Failed to store lead");
  //     }
  //   } catch (error) {
  //     console.error("Error submitting form:", error);
  //     toast.error("An error occurred while submitting the form");
  //   }
  // };
  const [isSubmitting, setIsSubmitting] = useState(false);


  const handleSubmit = async (e) => {
    e.preventDefault();

    const api = labelToApiNameMap.current;
    const statusValue = formData[api["Status"]];
    const idProofType = formData[api["ID Proof Type"]];
    const idProofNumber = formData[api["ID Proof Number"]];
    const subDisposition = formData["Sub_Disposition"];
    // coming from your conditional field

    // ✅ Set default "Face to Face" if IFR Lead Source is missing
    const ifrLeadSourceKey = api["IFR Lead Source"];
    if (!formData[ifrLeadSourceKey] || formData[ifrLeadSourceKey].trim() === "") {
      formData[ifrLeadSourceKey] = "Face to Face";
    }

    // Define base required fields
    const requiredFields = ["Last Name", "Mobile", "Email", "Contact Preferences", "Status", "Date of Birth", "First Name", "Gender"];

    // Add conditional required fields
    if (statusValue === "Interested Now" || statusValue === "Interested Later") {
      if (!subDisposition || subDisposition.trim() === "") {
        toast.error("Please select a Sub Disposition.");
        return;
      }
    }

    // ✅ Validate Donation Amount (prevent negative)
    const donationAmount = formData["Donation_Amount"];
    if (donationAmount && parseFloat(donationAmount) < 0) {
      toast.error("Donation Amount cannot be negative.");
      return;
    }


    if (statusValue === "Interested Now") {
      requiredFields.push("ID Proof Type");

      // Validate ID Proof Number
      if (!idProofNumber || idProofNumber.trim() === "") {
        toast.error("Please enter ID Proof Number.");
        return;
      }

      if (idProofType === "Aadhar Card" && !/^\d{12}$/.test(idProofNumber)) {
        toast.error("Please enter a valid 12-digit Aadhaar number.");
        return;
      }

      if (idProofType === "PAN Card" && !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(idProofNumber)) {
        toast.error("Please enter a valid PAN number.");
        return;
      }

      if (idProofType === "Voter ID Card" && !/^[A-Z0-9]{10,}$/.test(idProofNumber)) {
        toast.error("Please enter a valid Voter ID.");
        return;
      }
    }

    const dobValue = formData["Date_of_Birth"];
    if (dobValue) {
      const dobDate = new Date(dobValue);
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Strip time for accurate comparison

      if (dobDate > today) {
        toast.error("Date of Birth cannot be a future date.");
        return;
      }
    }



    const mobileLabel = "Mobile"; // change if your input label is different
    const mobileApiName = api[mobileLabel]; // gets the API field name for 'Phone'
    const mobileNumber = formData[mobileApiName];

    // Regex: exactly 10 digits, no letters, no symbols, no longer/shorter
    if (!mobileNumber || !/^\d{10}$/.test(mobileNumber.trim())) {
      toast.error("Please enter a valid 10-digit phone number.");
      return;
    }

    // Email validation
    const emailLabel = "Email"; // Change if your field label is different
    const emailApiName = api[emailLabel]; // Get API name for Email field
    const emailValue = formData[emailApiName]?.trim();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailValue || !emailRegex.test(emailValue)) {
      toast.error("Please enter a valid email address.");
      return;
    }

    // Check for other missing required fields
    const missingFields = requiredFields.filter((label) => {
      const apiName = api[label];
      return !formData[apiName] || formData[apiName].trim() === "";
    });

    if (missingFields.length > 0) {
      toast.error(`Please fill the following required field(s): ${missingFields.join(", ")}`);
      return;
    }
    // ✅ Validate Payment_URL format
    const paymentUrl = formData[api["Payment URL"]];
    if (
      paymentUrl &&
      !/^https?:\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/.test(paymentUrl)
    ) {
      toast.error("Please enter a valid public Payment URL (e.g. https://example.com).");
      return;
    }



    setIsSubmitting(true);


    // Prepare transformed data
    const subDispositionKey = api["Sub Dispositions"];
    const transformedData = {
      ...formData,
      Sub_Disposition: formData["Sub_Disposition"] || "",
    };


    // Catalyst User logic (optional based on your use case)
    const selectedCatalystUser = catalystUsers.find(
      (user) => user.Name === dealerDetail.Name
    );

    if (selectedCatalystUser) {
      transformedData.Catalyst_User = {
        id: selectedCatalystUser.id,
        name: selectedCatalystUser.Name,
      };
      transformedData.Catalyst_User_Email = selectedCatalystUser.Email;
    } else {
      transformedData.Catalyst_User = null;
      transformedData.Catalyst_User_Email = "";
    }

    const requestBody = {
      data: [transformedData],
    };

    try {
      const response = await fetch("/server/dealer_backend/handleLeads", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const result = await response.json();
      const idFetch = result.data.data[0].details?.id;

      if (result.status === "success") {
        toast.success("Data stored successfully!");
        navigate(`/owner-details/${idFetch}`);
        localStorage.removeItem("leadFormDraft");

        // Clear form
        setFormData((prev) =>
          Object.keys(prev).reduce((acc, key) => {
            acc[key] = "";
            return acc;
          }, {})



        );
        // ✅ Re-enable submit button
        setIsSubmitting(false); // 👈 Add this line
      } else {
        console.error("Error:", result.error);
        toast.error("Failed to store data");
        setIsSubmitting(false); // 🔁 Re-enable Save button
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("An error occurred while submitting the form");
      setIsSubmitting(false); // 🔁 Re-enable Save button
    }
  };



  const handleSaveDraft = () => {
    try {
      localStorage.setItem("leadFormDraft", JSON.stringify(formData));
      toast.success("Draft saved successfully!");
    } catch (error) {
      console.error("Error saving draft:", error);
      toast.error("Failed to save draft.");
    }
  };


  useEffect(() => {
    const savedDraft = localStorage.getItem("leadFormDraft");
    if (savedDraft) {
      try {
        const parsedDraft = JSON.parse(savedDraft);
        setFormData((prev) => ({ ...prev, ...parsedDraft }));
      } catch (e) {
        console.error("Failed to load draft:", e);
      }
    }
  }, []);










  const [catalystUsers, setCatalystUsers] = useState([]);

  useEffect(() => {
    const fetchCatalystUsers = async () => {
      try {
        const response = await fetch("/server/dealer_backend/getCatalystUsers");
        const data = await response.json();
        // console.log(data)
        if (data.status === "success") {
          setCatalystUsers(data.data);
        } else {
          console.error("Failed to fetch Catalyst Users:", data.error);
        }
      } catch (error) {
        console.error("Error fetching Catalyst Users:", error);
      }
    };

    fetchCatalystUsers();
  }, []);



  const labelToApiNameMap = useRef({});

  const fetchPickListValues = async (id) => {

    try {
      const response = await fetch(`/server/dealer_backend/getPickListValues/${id}?module=${module}`);
      const data = await response.json();

      if (data.status === "success") {
        setOptions((prev) => ({
          ...prev,
          [id]: data.data,
        }));
      } else {
        console.error("Failed to fetch pick list values:", data.error);
      }
    } catch (error) {
      console.error("Error fetching pick list values:", error);
    }
  };

  useEffect(() => {
    // Fetch picklist values
    sections.forEach((section) => {
      section.fields?.forEach((field) => {
        if (field.data_type === "picklist") {
          if (!field.id) {
            console.warn("Missing field.id for picklist:", field);
          } else {
            fetchPickListValues(field.id);
          }
        }
      });
    });

    // Map display labels to field names
    const map = {};
    sections.forEach(section => {
      section.fields.forEach(field => {
        map[field.display_label] = field.name;
      });
    });
    labelToApiNameMap.current = map;
  }, [sections]);

  const [salutation, setSalutation] = useState("");

  const interestedNowOptions = [
    "Donated on the spot",
    "Will donate later",
    "Asked for donation link",
    "Need more information/followup"
  ];

  const interestedLaterOptions = [
    "Already supporting",
    "Financial constraints",
    "Avoided conversation",
    "No reason given"
  ];











  return (
    <div className="LeadsPage">
      <ToastContainer position="top-right" autoClose={3000} />
      {isFieldsLoading ? (
        <div className="flex justify-center items-center h-screen">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500 border-solid"></div>
        </div>
      ) : (
        <div className="edit-container">
          <form onSubmit={(e) => e.preventDefault()}>
            {/* Section 1: Basic Information - Two Columns */}
            <div className="form-section two-columns">
              <div className="lead-buttons flex flex-wrap">
                <h3 className="text-xl font-bold">Create Potential Donor</h3>
                <div>
                  {fields.length > 0 && (
                    <>
                      <button
                        type="button"
                        className="draft-button mb-2 ml-0"
                        onClick={handleSaveDraft}
                      >
                        Save as Draft
                      </button>

                      <button
                        className="save-button mb-2 ml-2"
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                        style={{
                          opacity: isSubmitting ? 0.6 : 1,
                          pointerEvents: isSubmitting ? "none" : "auto",
                        }}
                      >
                        {isSubmitting ? "Saving..." : "Submit"}
                      </button>
                    </>
                  )}

                  <button
                    type="button"
                    className="cancel-button mb-2 ml-2"
                    disabled={isSubmitting}
                    onClick={() => {
                      // Clear form
                      setFormData((prev) =>
                        Object.keys(prev).reduce((acc, key) => {
                          acc[key] = "";
                          return acc;
                        }, {})
                      );

                      // Clear draft from localStorage
                      const userId = dealerDetail?.Email || "anonymous";
                      localStorage.removeItem(`leadFormDraft_${userId}`);

                      // Navigate
                      navigate('/potential-donor')
                    }}
                  >
                    Cancel
                  </button>

                </div>



              </div>
              <hr className="mb-4" />
              <div className="lead-form">
                {sections
                  .filter(section =>
                    section.type === "used" &&
                    !["Potential Donor Image", "Visit Summary", "Catalyst User", "System Information"].includes(section.display_label) &&
                    (section.display_label !== "Face to Face Information" ||
                      formData[labelToApiNameMap.current["IFR Lead Source"]] === "Face to Face")
                  )
                  .map(section => {
                    let sectionFields = section.fields.filter(
                      field => field.type === "used" && field.display_label
                    );

                    if (section.display_label === "Potential Donor Information") {
                      const excludedFields = [
                        "Unsubscribed Time", "Lead Status", "Purpose Type", "Donor Type", "Donor Potential Type",
                        "Contact Method", "Created By", "Lead Owner", "Modified By", "Full Name", "Salutation",
                        "Layout", "Currency", "Tag", "Donor type", "Last Activity Time",
                        "Record Status", "Lead Conversion Time", "Converted Date Time", "Modified Time", "Created Time",
                        "Exchange Rate", "Locked", "Enrich Status", "Last Enriched Time", "Change Log Time", "Record Id",
                        "Converted Deal", "Converted Account", "Is Converted", "Unsubscribed Mode", "Converted Contact", "PAN Number", "Sub Dispositions", "Event Name",
                        ...(formData[labelToApiNameMap.current["IFR Lead Source"]] !== "Face to Face"
                          ? ["Payment Type", "Donation Amount", "Mode of Payment"]
                          : []),
                          ...(formData[labelToApiNameMap.current["IFR Lead Source"]] === "Face to Face"
                          ? ["Call Dispositions"]
                          : []),
                           ...(formData[labelToApiNameMap.current["IFR Lead Source"]] === "Face to Face"
                          ? ["List Name"]
                          : [])
                      ];

                      sectionFields = sectionFields.filter(field => !excludedFields.includes(field.display_label));
                    }

                    if (section.display_label === "Description Information") {
                      const excludedFields = [
                        "Already a Existing Donor?", "Follow Up Date Time", "Number of RNR", "Last Call Date"
                      ];
                      sectionFields = sectionFields.filter(field => !excludedFields.includes(field.display_label));
                    }

                    if (sectionFields.length === 0) return null;

                    return (
                      <div key={section.display_label} className="form-section">
                        <h3>{section.display_label}</h3>
                        <div className={`form-section-fields grid  gap-2 ${section.column_count === 2 ? "two-columns" : ""}`}>

                          {sectionFields.map((field) => {
                            const label = field.display_label;
                            const api = labelToApiNameMap.current;
                            const isStatusInterested = formData[api["Status"]] === "Interested Now";

                            if (label === "Status") {
                              return (
                                <div key={field.field_label} className="form-fields">
                                  <label htmlFor={field.field_label} className="block mb-1">
                                    {label} <span className="text-red-500">*</span>
                                  </label>
                                  {renderInputField(field)}

                                  {(formData[api["Status"]] === "Interested Now" ||
                                    formData[api["Status"]] === "Interested Later") && (
                                      <div className="form-fields mt-2">
                                        <label htmlFor={api["Sub Dispositions"]} className="block mb-1">
                                          Sub Dispositions<span className="text-red-500 ml-1">*</span>
                                        </label>
                                        <select
                                          id={api["Sub Dispositions"]}
                                          name={api["Sub Dispositions"]}
                                          className="form-select border border-gray-300 p-2 w-full"
                                          value={formData[api["Sub Dispositions"]] || ""}
                                          onChange={(e) =>
                                            setFormData((prev) => ({
                                              ...prev,
                                              [api["Sub Dispositions"]]: e.target.value,
                                            }))
                                          }
                                        >
                                          <option value="">Select</option>
                                          {(formData[api["Status"]] === "Interested Now"
                                            ? interestedNowOptions
                                            : interestedLaterOptions
                                          ).map((option) => (
                                            <option key={option} value={option}>
                                              {option}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                    )}
                                </div>
                              );
                            }

                            const alwaysRequired = ["Last Name", "Mobile", "Email", "Contact Preferences", "Status", "Donor Interest", "First Name", "Gender", "Date of Birth", "Sub Dispositions"];
                            const conditionallyRequired = ["ID Proof Type", "ID Proof Number"];
                            const isAlwaysRequired = alwaysRequired.includes(label);
                            const isConditionallyRequired = isStatusInterested && conditionallyRequired.includes(label);

                            return (
                              <div key={field.field_label} className="form-fields">
                                <label htmlFor={field.field_label} className="block mb-1">
                                  {label}
                                  {(isAlwaysRequired || isConditionallyRequired) && (
                                    <span className="text-red-500 ml-1">*</span>
                                  )}
                                </label>

                                {renderInputField(field, {
                                  isRequired: isAlwaysRequired || isConditionallyRequired,
                                })}
                              </div>
                            );

                          })}
                        </div>
                      </div>
                    );
                  })}

              </div>






            </div>
          </form>
        </div>
      )}
    </div>




  );
};

export default ContactsPage;
